module.exports = __webpack_public_path__ + "img/yuan.18d538b5.png";